/* CG restaurant ordering (Round 22, R58 Oct 25 2026: Toast choices as variants)
   Item sheet, order setup (pickup/delivery, ASAP/scheduled, zip check) and cart bar for the
   dine-in menu page (sections/cg-menu-app.liquid) and dish pages (snippets/cg-menu-buy.liquid).
   Round 23: setup writes cart attributes Order Type / Requested Time / Pickup Time ISO / Delivery Zip
   so Checkmate can map them to the Toast order; config comes from snippets/cg-menu-config.liquid.
   Only active when the section is in "native" order mode. In external mode the
   cards link out and this file does nothing.

   Checkmate rule (confirmed Sep 25 2026): each modifier lands on the line item as a
   property whose NAME is the exact Toast modifier group name and whose VALUE is the
   exact Toast option name. Multi-select groups send one property per pick with the
   group name suffixed " (2)", " (3)" so the names stay unique; Checkmate matches the
   base name on the first, the numbered ones are on the test-call question list.

   Upcharges: window.CGM_CONFIG.upchargeMode
     "properties" (default) - the upcharge is shown and summed on the sheet but the
                              cart charges the base price only (Toast prices the
                              modifier on its side). Use until Checkmate confirms how
                              they want paid upcharges represented.
     "addon"                - adds a hidden add-on variant per price point so Shopify
                              collects the money. Needs CGM_CONFIG.addonVariants
                              {"100": <variantId for $1.00>, ...}.
*/
(function () {
  'use strict';
  if (window.CGMenu) return;
  var CFG = window.CGM_CONFIG || {};
  var MODE = CFG.upchargeMode || 'properties';
  var ADDONS = CFG.addonVariants || {};
  var PREP = CFG.prepMinutes || 15;
  var PAUSED = !!CFG.asapPaused;
  var TZ = CFG.timeZone || 'America/Los_Angeles';
  var HOURS = CFG.hours || {}, HOLIDAYS = CFG.holidays || [], LOAD = CFG.loadTable || [];
  var CUTOFF = CFG.cutoffMinutes || 0, SLOT = CFG.slotMinutes || 15, MAXDAYS = CFG.maxDaysAhead || 7, LEAD = CFG.leadMinutes || PREP;
  var ZONES = (CFG.zones || []).filter(function (z) { return z.active !== false; });
  var DELIVERY_MIN = CFG.deliveryMinimum || 0, DELIVERY_FEE = CFG.deliveryFee || 0, PICKUP_MIN = CFG.pickupMinimum || 0;
  var CHECKOUT_URL = CFG.checkoutUrl || '/checkout';

  function el(s, r) { return (r || document).querySelector(s); }
  function els(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  /* R48 (Oct 16 2026): paid extras ride on the dish itself. Dishes with paid options have a
     product option "Add-ons" (values None, +$2.50, +$5.99, ...) whose variants carry the
     upcharge in their price. The sheet picks the variant for the chosen size + extras total,
     so Shopify charges the right amount on ONE line and Checkmate only sees the dish
     (its Toast modifiers still go as properties). No separate "Menu Add-ons" line. */
  var TIER = 'Add-ons';
  function tierIdx(p) { return (p.onames || []).indexOf(TIER); }
  function tierLabel(c) { return c > 0 ? '+$' + (c / 100).toFixed(2) : 'None'; }
  /* R58 (Oct 25 2026): Checkmate reads the VARIANT title as the Toast modifier and ignores line item
     properties. So a dish's must-pick Toast groups (and the burger/sandwich side, where Onion Rings and
     Zucchini are paid upgrades) are real Shopify options named exactly like the Toast group, with values
     named exactly like the Toast options. The sheet shows them as normal choices and adds the matching
     variant; its price carries any upgrade, so the guest pays on ONE line and Toast gets the modifier.
     encIdx = positions of those options. The properties are still sent so the order page shows them. */
  function encIdx(p) {
    if (p.__enc) return p.__enc;
    var names = (p.groups || []).map(function (g) { return g.name; }), out = [];
    (p.onames || []).forEach(function (n, i) { if (names.indexOf(n) > -1) out.push(i); });
    return (p.__enc = out);
  }
  function encBase(p, i) { return ((p.variants[0] || {}).opts || [])[i]; }
  function encValues(p, i) { var seen = [], out = []; p.variants.forEach(function (v) { var x = (v.opts || [])[i]; if (x != null && seen.indexOf(x) < 0) { seen.push(x); out.push(x); } }); return out; }
  function sizeKey(p, v) { var t = tierIdx(p), en = encIdx(p); return (v.opts || [v.title]).filter(function (x, i) { return i !== t && en.indexOf(i) < 0; }).join(' / '); }
  function baseVariants(p) {
    var t = tierIdx(p), en = encIdx(p);
    var vs = t < 0 ? p.variants : p.variants.filter(function (v) { return (v.opts || [])[t] === 'None'; });
    if (en.length) vs = vs.filter(function (v) { return en.every(function (i) { return (v.opts || [])[i] === encBase(p, i); }); });
    return vs.length ? vs : p.variants.slice(0, 1);
  }
  function encVariant(p, bv, props) {
    var en = encIdx(p), k = sizeKey(p, bv);
    var want = {}; en.forEach(function (i) { var n = p.onames[i]; want[i] = props[n] != null && props[n] !== '' ? String(props[n]) : encBase(p, i); });
    return p.variants.filter(function (v) { return sizeKey(p, v) === k && en.every(function (i) { return v.opts[i] === want[i]; }); })[0] || null;
  }
  function pickVariant(p, baseV, up) {
    var t = tierIdx(p); if (t < 0) return up > 0 ? null : baseV;
    var k = sizeKey(p, baseV), want = tierLabel(up);
    return p.variants.filter(function (v) { return v.opts[t] === want && sizeKey(p, v) === k; })[0] || null;
  }
  function cleanVariantTitle(t) { return String(t || '').split(' / ').filter(function (x) { return x !== 'None' && x.charAt(0) !== '+' && x !== 'Default Title'; }).join(' / '); }
  function lineVariantTitle(it) {
    var p = products[it.product_id];
    if (p && encIdx(p).length) { var v = p.variants.filter(function (x) { return +x.id === +it.variant_id; })[0]; var k = v ? sizeKey(p, v) : ''; return k === 'Default Title' ? '' : k; }
    return cleanVariantTitle(it.variant_title);
  }

  /* ---------- cart ---------- */
  var cart = null, listeners = [];
  function onCart(fn) { listeners.push(fn); if (cart) fn(cart); }
  function emit() { listeners.forEach(function (f) { try { f(cart); } catch (e) {} }); }
  function loadCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cart = c; emit(); return c; });
  }
  function addItems(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to order'); return j; }); })
      .then(loadCart);
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function (c) { cart = c; emit(); });
  }
  /* R46 (Oct 14 2026): paid extras are separate "Menu Add-ons" lines (assets/cg-fixes.js) tied to their dish by
     the _link property. Every quantity change, removal and edit here moves the dish and its extras together in one
     /cart/update.js call, so totals never show a dish without its charges or charges without their dish. */
  function isAddon(it) { return !!(it && ((it.properties && it.properties._addon === '1') || /\/products\/menu-add-ons/.test(it.url || ''))); }
  function addonsFor(c, parent) {
    var L = parent && parent.properties && parent.properties._link; if (!L || !c) return [];
    return (c.items || []).filter(function (i) { return isAddon(i) && i.properties && i.properties._link === L; });
  }
  function mealCount(c) { return ((c && c.items) || []).reduce(function (n, i) { return isAddon(i) ? n : n + i.quantity; }, 0); }
  var busy = false;
  function setDish(line, qty) {
    var updates = {}; updates[line.key] = qty;
    addonsFor(cart, line).forEach(function (a) { updates[a.key] = qty; });
    busy = true;
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(function (r) { return r.json(); })
      .then(function () { return new Promise(function (res) { setTimeout(res, 350); }); })
      .then(loadCart)
      .then(function (c) { busy = false; refreshBubble(); return c; }, function (e) { busy = false; return loadCart().then(function () { throw e; }); });
  }
  function refreshBubble() {
    try {
      fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
        var w = document.getElementById('cart-icon-bubble');
        if (w && s['cart-icon-bubble']) { var t = document.createElement('div'); t.innerHTML = s['cart-icon-bubble']; var i = t.querySelector('#cart-icon-bubble') || t; w.innerHTML = i.innerHTML; }
      });
    } catch (e) {}
  }


  /* ---------- order setup: pickup or delivery, ASAP or scheduled, zip ---------- */
  var DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  var DAYN = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  /* "now" as wall-clock parts in the restaurant's time zone, whatever the guest's device says */
  function laParts(d) {
    d = d || new Date();
    try {
      var f = new Intl.DateTimeFormat('en-US', { timeZone: TZ, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', weekday: 'short' });
      var o = {}; f.formatToParts(d).forEach(function (x) { o[x.type] = x.value; });
      var h = +o.hour; if (h === 24) h = 0;
      return { y: +o.year, m: +o.month, d: +o.day, h: h, mi: +o.minute, dow: DAYS.indexOf(o.weekday.toLowerCase().slice(0, 3)) };
    } catch (e) { return { y: d.getFullYear(), m: d.getMonth() + 1, d: d.getDate(), h: d.getHours(), mi: d.getMinutes(), dow: d.getDay() }; }
  }
  function laOffset(d) {
    try {
      var f = new Intl.DateTimeFormat('en-US', { timeZone: TZ, timeZoneName: 'longOffset' });
      var p = f.formatToParts(d).filter(function (x) { return x.type === 'timeZoneName'; })[0];
      if (p && /GMT[+-]/.test(p.value)) { var v = p.value.replace('GMT', ''); if (v.indexOf(':') < 0) v += ':00'; return v; }
    } catch (e) {}
    /* fallback: US Pacific DST rule */
    var pp = laParts(d), dst = false;
    if (pp.m > 3 && pp.m < 11) dst = true; else if (pp.m === 3) dst = pp.d >= 8 + ((7 - new Date(pp.y, 2, 8).getDay()) % 7) && true; else if (pp.m === 11) dst = pp.d < 1 + ((7 - new Date(pp.y, 10, 1).getDay()) % 7);
    return dst ? '-07:00' : '-08:00';
  }
  function dateKey(p) { return p.y + '-' + pad(p.m) + '-' + pad(p.d); }
  function addDays(p, n) { var d = new Date(Date.UTC(p.y, p.m - 1, p.d + n)); return { y: d.getUTCFullYear(), m: d.getUTCMonth() + 1, d: d.getUTCDate(), dow: d.getUTCDay() }; }
  function hm(str) { var a = String(str || '').split(':'); return (+a[0] || 0) * 60 + (+a[1] || 0); }
  function windowFor(p) {
    var key = dateKey(p), ov = null;
    HOLIDAYS.forEach(function (h) { if (h && h.date === key) ov = h; });
    if (ov) { if (!ov.open || !ov.close) return { closed: true, note: ov.note || 'Closed' }; return { open: hm(ov.open), close: hm(ov.close), note: ov.note || '' }; }
    var h = HOURS[DAYS[p.dow]]; if (!h || !h[0] || !h[1]) return { closed: true, note: 'Closed' };
    return { open: hm(h[0]), close: hm(h[1]), note: '' };
  }
  function loadExtra(p, minutesOfDay) {
    var add = 0;
    LOAD.forEach(function (r) { if (!r || !r.days) return; if (r.days.indexOf(DAYS[p.dow]) < 0) return; var f = hm(r.from), t = hm(r.to); if (minutesOfDay >= f && minutesOfDay < t) add = Math.max(add, +r.add_minutes || 0); });
    return add;
  }
  function fmtTime(mins) { var h = Math.floor(mins / 60) % 24, m = mins % 60, ap = h >= 12 ? 'PM' : 'AM'; h = h % 12 || 12; return h + ':' + pad(m) + ' ' + ap; }
  /* ASAP: is the kitchen taking orders right now, and when would this be ready */
  function asapInfo() {
    var p = laParts(), w = windowFor(p), nowM = p.h * 60 + p.mi;
    if (PAUSED) return { ok: false, why: 'ASAP orders are paused right now. Pick a time instead.' };
    if (w.closed) return { ok: false, why: CFG.closedMessage || 'We are closed right now. Schedule an order for later.' };
    if (nowM < w.open) return { ok: false, why: 'We open at ' + fmtTime(w.open) + '. Schedule an order for later.' };
    if (nowM > w.close - CUTOFF) return { ok: false, why: 'The kitchen stops taking orders ' + CUTOFF + ' minutes before close. Schedule one for tomorrow.' };
    var mins = PREP + loadExtra(p, nowM);
    return { ok: true, minutes: mins, readyAt: nowM + mins, label: fmtTime(nowM + mins) };
  }
  /* scheduling: list of days with open slots */
  function slotDays() {
    var today = laParts(), out = [];
    for (var i = 0; i <= MAXDAYS; i++) {
      var p = addDays(today, i), w = windowFor(p); if (w.closed) continue;
      var first = w.open + Math.max(LEAD, PREP), last = w.close - CUTOFF;
      if (i === 0) { var nowM = today.h * 60 + today.mi + Math.max(LEAD, PREP); first = Math.max(first, Math.ceil(nowM / SLOT) * SLOT); }
      var slots = []; for (var t = Math.ceil(first / SLOT) * SLOT; t <= last; t += SLOT) slots.push(t);
      if (!slots.length) continue;
      out.push({ key: dateKey(p), label: (i === 0 ? 'Today' : i === 1 ? 'Tomorrow' : DAYN[p.dow].slice(0, 3)) + ', ' + MONN[p.m - 1] + ' ' + p.d, slots: slots, p: p });
    }
    return out;
  }
  function zoneFor(zip) {
    zip = String(zip || '').replace(/\D/g, '').slice(0, 5); if (zip.length < 5) return null;
    var hit = null;
    ZONES.forEach(function (z) { if (hit) return; (z.zips || []).forEach(function (pre) { if (!hit && zip.indexOf(String(pre)) === 0) hit = z; }); });
    return hit;
  }
  var SETUP_KEY = 'cgm_setup_v1';
  var setup = { mode: 'pickup', when: 'asap', date: '', time: 0, zip: '' };
  try { var sv = JSON.parse(localStorage.getItem(SETUP_KEY) || 'null'); if (sv && sv.mode) setup = sv; } catch (e) {}
  function saveSetup() { try { localStorage.setItem(SETUP_KEY, JSON.stringify(setup)); } catch (e) {} }
  function setupValid() {
    if (setup.when === 'asap') { var a = asapInfo(); if (!a.ok) return { ok: false, why: a.why }; }
    else {
      var days = slotDays(), d = days.filter(function (x) { return x.key === setup.date; })[0];
      if (!d || d.slots.indexOf(+setup.time) < 0) return { ok: false, why: 'Pick a date and time for your order.' };
    }
    if (setup.mode === 'delivery') {
      var z = zoneFor(setup.zip); if (!z) return { ok: false, why: setup.zip ? 'We do not deliver to ' + setup.zip + ' yet. Pickup is always available.' : 'Enter your delivery zip.' };
      var min = z.minimum || DELIVERY_MIN; if (cart && min && (cart.items_subtotal_price || 0) < min) return { ok: false, why: 'Delivery orders are ' + money(min) + ' minimum. Add ' + money(min - cart.items_subtotal_price) + ' more, or switch to pickup.', soft: true };
    } else if (PICKUP_MIN && cart && (cart.items_subtotal_price || 0) < PICKUP_MIN) return { ok: false, why: 'Pickup orders are ' + money(PICKUP_MIN) + ' minimum.', soft: true };
    return { ok: true };
  }
  function setupSummary() {
    var mode = setup.mode === 'delivery' ? 'Delivery' : 'Pickup';
    if (setup.when === 'asap') { var a = asapInfo(); return a.ok ? mode + ' ASAP · ready by ' + a.label : mode + ' · ' + (PAUSED ? 'schedule at checkout' : 'pick a time'); }
    var d = slotDays().filter(function (x) { return x.key === setup.date; })[0];
    return mode + ' · ' + (d ? d.label + ' ' + fmtTime(+setup.time) : 'pick a time');
  }
  function requestedISO() {
    var p, mins;
    if (setup.when === 'asap') { var a = asapInfo(); if (!a.ok) return ''; p = laParts(); mins = a.readyAt; }
    else { var a2 = setup.date.split('-'); p = { y: +a2[0], m: +a2[1], d: +a2[2] }; mins = +setup.time; }
    if (mins >= 1440) { p = addDays(p, 1); mins -= 1440; }
    var local = p.y + '-' + pad(p.m) + '-' + pad(p.d) + 'T' + pad(Math.floor(mins / 60)) + ':' + pad(mins % 60) + ':00';
    return local + laOffset(new Date(local));
  }
  function cartAttributes() {
    var iso = requestedISO(), a = {
      'Order Type': setup.mode === 'delivery' ? 'Delivery' : 'Pickup',
      'Channel': 'restaurant',
      'Requested Time': setup.when === 'asap' ? 'ASAP' : setupSummary().replace(/^\w+ · /, ''),
      'Pickup Time ISO': iso,
      'Delivery Zip': setup.mode === 'delivery' ? String(setup.zip || '') : ''
    };
    return a;
  }
  var attrTimer = null;
  function pushAttributes() {
    clearTimeout(attrTimer);
    attrTimer = setTimeout(function () {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: cartAttributes() }) })
        .then(function (r) { return r.json(); }).then(function (c) { cart = c; emit(); }).catch(function () {});
    }, 150);
  }
  var setupEl;
  function ensureSetup() {
    if (setupEl) return setupEl;
    setupEl = document.createElement('div'); setupEl.className = 'cgc cgc-modal cgm-setup';
    setupEl.setAttribute('role', 'dialog'); setupEl.setAttribute('aria-modal', 'true');
    document.body.appendChild(setupEl);
    setupEl.addEventListener('click', function (e) { if (e.target === setupEl || e.target.classList.contains('cgc-modal__close')) closeSetup(); });
    return setupEl;
  }
  function closeSetup() { if (setupEl) { setupEl.classList.remove('is-open'); document.body.style.overflow = ''; } }
  function openSetup() {
    ensureSetup();
    var days = slotDays(), asap = asapInfo(), h = '';
    h += '<div class="cgc-modal__panel"><button type="button" class="cgc-modal__close" aria-label="Close">×</button><div class="cgc-modal__body"><h3>How do you want it?</h3>';
    h += '<div class="cgc-setup__mode cgm-setup__mode" role="group"><button type="button" data-mode="pickup" aria-pressed="' + (setup.mode !== 'delivery') + '">Pickup</button><button type="button" data-mode="delivery" aria-pressed="' + (setup.mode === 'delivery') + '">Delivery</button></div>';
    h += '<p class="cgm-setup__note" data-modenote></p>';
    h += '<div class="cgc-opt"><span class="cgc-opt__title">When</span><div class="cgc-choice cgm-when">';
    h += '<label' + (asap.ok ? '' : ' class="is-off"') + '><input type="radio" name="cgm-when" value="asap"' + (setup.when === 'asap' && asap.ok ? ' checked' : '') + (asap.ok ? '' : ' disabled') + '><span>ASAP</span><span class="cgc-choice__price">' + (asap.ok ? 'ready by ' + asap.label : 'not right now') + '</span></label>';
    h += '<label><input type="radio" name="cgm-when" value="later"' + (setup.when !== 'asap' || !asap.ok ? ' checked' : '') + '><span>Schedule</span><span class="cgc-choice__price">up to ' + MAXDAYS + ' days out</span></label>';
    h += '</div>' + (asap.ok ? '' : '<p class="cgm-setup__why">' + esc(asap.why) + '</p>') + '</div>';
    h += '<div class="cgm-setup__sched" data-sched><div class="cgc-field"><label for="cgm-date">Date</label><select id="cgm-date" data-date>' + days.map(function (d) { return '<option value="' + d.key + '"' + (d.key === setup.date ? ' selected' : '') + '>' + esc(d.label) + '</option>'; }).join('') + '</select></div><div class="cgc-field"><label for="cgm-time">Time</label><select id="cgm-time" data-time></select></div></div>';
    h += '<div class="cgm-setup__zip" data-zipwrap><div class="cgc-field"><label for="cgm-zip">Delivery zip</label><input type="text" inputmode="numeric" maxlength="5" id="cgm-zip" placeholder="90601" value="' + esc(setup.zip) + '" data-zip><div class="cgc-setup__zipmsg" data-zipmsg></div></div></div>';
    h += '<p class="cgc-modal__hint">6751 Painter Ave, Whittier. Pickup has no minimum. Delivery ' + (DELIVERY_FEE ? money(DELIVERY_FEE) + ' fee, ' : '') + (DELIVERY_MIN ? money(DELIVERY_MIN) + ' minimum' : 'fee shown at checkout') + '.</p>';
    h += '</div><div class="cgc-modal__foot"><button type="button" class="cgc-add" data-done>Done</button></div></div>';
    setupEl.innerHTML = h;
    var dateSel = el('[data-date]', setupEl), timeSel = el('[data-time]', setupEl), zipIn = el('[data-zip]', setupEl), zipMsg = el('[data-zipmsg]', setupEl);
    function fillTimes() {
      var d = days.filter(function (x) { return x.key === dateSel.value; })[0]; if (!d) { timeSel.innerHTML = '<option value="">No times</option>'; return; }
      timeSel.innerHTML = d.slots.map(function (t) { return '<option value="' + t + '"' + (t === +setup.time ? ' selected' : '') + '>' + fmtTime(t) + '</option>'; }).join('');
    }
    function paintMode() {
      var del = setup.mode === 'delivery';
      els('[data-mode]', setupEl).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.mode === setup.mode)); });
      el('[data-zipwrap]', setupEl).style.display = del ? '' : 'none';
      el('[data-modenote]', setupEl).textContent = del ? 'Local delivery around Whittier. Enter your zip to check.' : 'Come to the front counter at 6751 Painter Ave and give your name.';
      el('[data-sched]', setupEl).style.display = (el('input[name="cgm-when"]:checked', setupEl) || {}).value === 'later' ? '' : 'none';
    }
    function paintZip() {
      var z = zoneFor(zipIn.value); zipMsg.className = 'cgc-setup__zipmsg ' + (z ? 'ok' : (zipIn.value.length >= 5 ? 'warn' : ''));
      zipMsg.textContent = z ? 'We deliver to ' + zipIn.value + (z.drive_minutes ? ' · about ' + z.drive_minutes + ' min' : '') + (z.minimum || DELIVERY_MIN ? ' · ' + money(z.minimum || DELIVERY_MIN) + ' minimum' : '') : (zipIn.value.length >= 5 ? 'Not in our delivery area yet. Pickup is always available.' : '');
    }
    els('[data-mode]', setupEl).forEach(function (b) { b.addEventListener('click', function () { setup.mode = b.dataset.mode; paintMode(); }); });
    setupEl.addEventListener('change', function (e) { if (e.target.name === 'cgm-when') { setup.when = e.target.value; paintMode(); } });
    dateSel.addEventListener('change', fillTimes);
    zipIn.addEventListener('input', function () { setup.zip = zipIn.value.replace(/\D/g, '').slice(0, 5); paintZip(); });
    if (!days.filter(function (x) { return x.key === setup.date; }).length && days.length) setup.date = days[0].key;
    dateSel.value = setup.date; fillTimes(); paintMode(); paintZip();
    el('[data-done]', setupEl).addEventListener('click', function () {
      setup.when = (el('input[name="cgm-when"]:checked', setupEl) || {}).value || 'later';
      if (setup.when === 'later') { setup.date = dateSel.value; setup.time = +timeSel.value || 0; }
      saveSetup(); pushAttributes(); paintSetup(); closeSetup();
    });
    setupEl.classList.add('is-open'); document.body.style.overflow = 'hidden';
  }
  function paintSetup() {
    var v = setupValid(), txt = setupSummary();
    els('[data-cgm-setup-summary]').forEach(function (n) { n.textContent = txt; });
    els('[data-cgm-setup-state]').forEach(function (n) { n.textContent = v.ok ? '' : v.why; n.hidden = v.ok; });
    if (bar) { el('[data-when]', bar).textContent = txt; }
    if (panel) {
      var pw = el('[data-pwhen]', panel); pw.innerHTML = esc(txt) + ' <button type="button" class="cgm-line__btn" data-change>Change</button>' + (v.ok ? '' : '<span class="cgm-panel__warn">' + esc(v.why) + '</span>');
      var co = el('.cgm-checkout', panel); if (co) { co.classList.toggle('is-blocked', !v.ok); co.setAttribute('aria-disabled', String(!v.ok)); }
    }
  }

  /* ---------- sheet ---------- */
  var sheet, toastEl;
  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'cgc cgc-modal cgm-sheet';
    sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true');
    sheet.innerHTML = '<div class="cgc-modal__panel"><button type="button" class="cgc-modal__close" aria-label="Close">×</button><div class="cgc-modal__content"></div></div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) { if (e.target === sheet || e.target.classList.contains('cgc-modal__close')) closeSheet(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
    toastEl = document.createElement('div'); toastEl.className = 'cgc cgc-toast'; document.body.appendChild(toastEl);
    return sheet;
  }
  var scrollY = 0;
  function openSheetShell() { ensureSheet(); scrollY = window.scrollY; sheet.classList.add('is-open'); document.body.style.overflow = 'hidden'; el('.cgc-modal__panel', sheet).scrollTop = 0; }
  function closeSheet() { if (sheet) { sheet.classList.remove('is-open'); document.body.style.overflow = ''; window.scrollTo(0, scrollY); } }
  function toast(msg) { ensureSheet(); toastEl.textContent = msg; toastEl.classList.add('is-visible'); clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2200); }

  /* R48: side and add-on photos. An option whose name matches a dish on the menu page (French Fries,
     Onion Rings, Sweet Potato Fries, Dinner Salad...) shows that dish's photo as a small thumbnail.
     No extra uploads: it reuses the product photos already on the page. */
  function normName(s) { return String(s || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]/g, ''); }
  var photoMap = null;
  function optPhoto(name) {
    if (!photoMap) {
      photoMap = {};
      Object.keys(products).forEach(function (k) { var p = products[k]; if (p && p.image) photoMap[normName(p.title)] = String(p.image).replace(/width=\d+/, 'width=120'); });
    }
    return photoMap[normName(name)] || '';
  }
  (function () {
    try {
      var st = document.createElement('style');
      st.textContent = '.cgm-opt__img{width:40px;height:40px;border-radius:8px;object-fit:cover;flex:none;background:#f3f1ec}';
      document.head.appendChild(st);
    } catch (e) {}
  })();

  function groupHtml(g, gi) {
    var multi = g.multi || (g.max && g.max > 1);
    var type = multi ? 'checkbox' : 'radio';
    var rule = g.required ? 'Required' : 'Optional';
    if (multi && g.max) rule += ' · pick up to ' + g.max;
    else if (multi) rule += ' · pick any';
    var h = '<div class="cgc-opt cgm-group" data-gi="' + gi + '" data-required="' + (g.required ? 1 : 0) + '" data-min="' + (g.min || 0) + '" data-max="' + (g.max || 0) + '" data-multi="' + (multi ? 1 : 0) + '">';
    h += '<span class="cgc-opt__title">' + esc(g.display || g.name) + ' <em class="cgm-rule">' + rule + '</em></span><div class="cgc-choice">';
    var preselect = false;
    g.options.forEach(function (o, oi) {
      var checked = '';
      if (!multi && g.required && !preselect && (o.default || oi === 0)) { checked = ' checked'; preselect = true; }
      else if (o.default) checked = ' checked';
      var ph = optPhoto(o.name);
      h += '<label' + (ph ? ' class="cgm-opt--img"' : '') + '><input type="' + type + '" name="cgm-g' + gi + '" value="' + esc(o.name) + '" data-price="' + (o.price || 0) + '"' + checked + '>' + (ph ? '<img class="cgm-opt__img" src="' + esc(ph) + '" alt="" loading="lazy" width="40" height="40">' : '') + '<span>' + esc(o.name) + '</span>' + (o.price ? '<span class="cgc-choice__price">+' + money(o.price) + '</span>' : '') + '</label>';
    });
    return h + '</div><p class="cgm-group__err" hidden>Pick one to continue</p></div>';
  }

  function openSheet(p, existing) {
    if (typeof existing === 'string') existing = ((cart && cart.items) || []).filter(function (i) { return i.key === existing; })[0] || null;
    openSheetShell();
    var host = el('.cgc-modal__content', sheet);
    var bvs = baseVariants(p), sizes = bvs.length > 1;
    /* R49 (Oct 16 2026): paid options are hidden until Checkmate can take upcharges. Every required group
       keeps at least one free option. Sides are offered instead as their own menu items (real Toast items),
       so the guest pays the right amount and the order injects cleanly. */
    var en = encIdx(p);
    var groups = (p.groups || []).map(function (g) {
      var oi = (p.onames || []).indexOf(g.name);
      if (oi > -1 && en.indexOf(oi) > -1) {
        var byName = {}; (g.options || []).forEach(function (o) { byName[o.name] = o; });
        return { name: g.name, display: g.display, required: true, multi: false, min: 1, max: 1, enc: true,
          options: encValues(p, oi).map(function (x, n) { return { name: x, price: (byName[x] && byName[x].price) || 0, default: n === 0 }; }) };
      }
      return { name: g.name, display: g.display, required: g.required, multi: g.multi, min: g.min, max: g.max, options: (g.options || []).filter(function (o) { return !(o.price > 0); }) };
    });
    var sides = sideList(p);
    var h = '';
    if (p.image) h += '<img class="cgc-modal__img" src="' + esc(p.image) + '" alt="">';
    h += '<div class="cgc-modal__body"><h3>' + esc(p.title) + '</h3>' + (p.desc ? '<p class="cgc-modal__desc">' + esc(p.desc) + '</p>' : '');
    h += '<div class="cgc-modal__price" data-cgm-price></div>';
    if (sizes) {
      h += '<div class="cgc-opt"><span class="cgc-opt__title">' + esc(p.option_name || 'Size') + ' <em class="cgm-rule">Required</em></span><div class="cgc-choice">';
      bvs.forEach(function (v, i) { h += '<label><input type="radio" name="cgm-var" value="' + v.id + '" data-price="' + v.price + '"' + (i === 0 ? ' checked' : '') + (v.available ? '' : ' disabled') + '><span>' + esc(sizeKey(p, v)) + '</span><span class="cgc-choice__price">' + money(v.price) + '</span></label>'; });
      h += '</div></div>';
    }
    var req = groups.filter(function (g) { return g.required && g.options.length; }), opt = groups.filter(function (g) { return !g.required && g.options.length; });
    req.forEach(function (g) { h += groupHtml(g, groups.indexOf(g)); });
    if (opt.length) {
      h += '<details class="cgm-extras"><summary>Add extras or make changes <span class="cgm-extras__n">' + opt.length + ' group' + (opt.length > 1 ? 's' : '') + '</span></summary>';
      opt.forEach(function (g) { h += groupHtml(g, groups.indexOf(g)); });
      h += '</details>';
    }
    if (sides.length) {
      h += '<div class="cgc-opt cgm-xsell"><span class="cgc-opt__title">Add a side <em class="cgm-rule">Optional</em></span><div class="cgc-choice">';
      sides.forEach(function (s) {
        var v = s.variants[0], ph = s.image ? String(s.image).replace(/width=\d+/, 'width=120') : '';
        h += '<label><input type="checkbox" data-xsell="' + v.id + '" data-price="' + v.price + '">' + (ph ? '<img class="cgm-opt__img" src="' + esc(ph) + '" alt="" loading="lazy" width="40" height="40">' : '') + '<span>' + esc(s.title) + '</span><span class="cgc-choice__price">+' + money(v.price) + '</span></label>';
      });
      h += '</div></div>';
    }
    h += '<div class="cgc-opt"><span class="cgc-opt__title">Quantity</span><div class="cgc-buy__row"><div class="cgc-qty"><button type="button" data-dec aria-label="Less">−</button><input type="number" inputmode="numeric" data-qty value="1" min="1" max="20"><button type="button" data-inc aria-label="More">+</button></div></div></div>';
    h += '<details class="cgm-extras cgm-notes"><summary>Special instructions</summary><div class="cgc-opt"><textarea data-notes maxlength="140" placeholder="Allergies? No onions? Tell the kitchen"></textarea></div></details>';
    h += '<p class="cgc-modal__err" data-err></p></div>';
    h += '<div class="cgc-modal__foot"><button type="button" class="cgc-add" data-submit>' + (existing ? 'Update' : 'Add to order') + ' <span data-total></span></button></div>';
    host.innerHTML = h;

    var qtyIn = el('[data-qty]', host), priceEl = el('[data-cgm-price]', host), totalEl = el('[data-total]', host), err = el('[data-err]', host);
    function qty() { var q = parseInt(qtyIn.value, 10); if (isNaN(q) || q < 1) q = 1; if (q > 20) q = 20; qtyIn.value = q; return q; }
    /* R58: the base variant already carries the price of its default choices; take that back out so the
       sheet total is base + picked upgrades (equals the variant price that goes to the cart) */
    var encBaseUp = 0; groups.forEach(function (g) { if (!g.enc) return; var oi = (p.onames || []).indexOf(g.name), b = encBase(p, oi); g.options.forEach(function (o) { if (o.name === b) encBaseUp += o.price || 0; }); });
    function base() { var r = el('input[name="cgm-var"]:checked', host); return (r ? +r.dataset.price : bvs[0].price) - encBaseUp; }
    function picks() {
      var out = [];
      els('.cgm-group', host).forEach(function (gEl) {
        var g = groups[+gEl.dataset.gi]; if (!g) return;
        els('input:checked', gEl).forEach(function (i) { out.push({ group: g.name, option: i.value, price: +i.dataset.price || 0 }); });
      });
      return out;
    }
    function xs() { return els('[data-xsell]:checked', host).reduce(function (s, i) { return s + (+i.dataset.price || 0); }, 0); }
    function paint() {
      var q = qty(), up = picks().reduce(function (s, x) { return s + x.price; }, 0), unit = base() + up, side = xs();
      priceEl.innerHTML = money(unit) + (side ? ' <small>+ ' + money(side) + ' sides</small>' : '');
      totalEl.textContent = '· ' + money((unit + side) * q);
      el('[data-dec]', host).disabled = q <= 1;
    }
    el('[data-dec]', host).addEventListener('click', function () { qtyIn.value = qty() - 1; paint(); });
    el('[data-inc]', host).addEventListener('click', function () { qtyIn.value = qty() + 1; paint(); });
    qtyIn.addEventListener('input', paint);
    host.addEventListener('change', function (e) {
      var i = e.target; if (!i.matches || !i.matches('input[type=checkbox]')) { paint(); return; }
      var gEl = i.closest('.cgm-group'); if (!gEl) { paint(); return; }
      var max = +gEl.dataset.max;
      if (max && els('input:checked', gEl).length > max) { i.checked = false; toast('Pick up to ' + max); }
      paint();
    });
    /* R46: Edit reopens the dish exactly as it was ordered: size, every choice, the note and the quantity */
    if (existing) {
      var ep = existing.properties || {};
      if (sizes) { var ev = p.variants.filter(function (v) { return +v.id === +existing.variant_id; })[0], ek = ev ? sizeKey(p, ev) : ''; els('input[name="cgm-var"]', host).forEach(function (r) { var bv = bvs.filter(function (v) { return +v.id === +r.value; })[0]; r.checked = !!bv && sizeKey(p, bv) === ek; }); }
      els('.cgm-group', host).forEach(function (gEl) {
        var g = groups[+gEl.dataset.gi], want = [];
        Object.keys(ep).forEach(function (k) { if (k === g.name || k.replace(/ \(\d+\)$/, '') === g.name) want.push(String(ep[k])); });
        if (!want.length) { if (gEl.dataset.multi === '1') els('input', gEl).forEach(function (i) { i.checked = false; }); return; }
        els('input', gEl).forEach(function (i) { i.checked = want.indexOf(i.value) > -1; });
        var d1 = gEl.closest('details.cgm-extras'); if (d1 && want.length) d1.open = true;
      });
      var note = ep['Special Instructions'];
      if (note) { var ta = el('[data-notes]', host); ta.value = String(note).replace(/^Side: French Fries\.?\s*/i, ''); var dn = ta.closest('details'); if (dn && ta.value) dn.open = true; }
      qtyIn.value = existing.quantity || 1;
    }
    paint();

    el('[data-submit]', host).addEventListener('click', function () {
      var btn = this; err.classList.remove('is-visible');
      var bad = null;
      els('.cgm-group', host).forEach(function (gEl) {
        var n = els('input:checked', gEl).length, min = +gEl.dataset.min, need = gEl.dataset.required === '1' ? Math.max(min, 1) : min;
        var e2 = el('.cgm-group__err', gEl);
        if (n < need && (n > 0 || gEl.dataset.required === '1')) { e2.hidden = false; e2.textContent = need > 1 ? 'Pick at least ' + need : 'Pick one to continue'; if (!bad) bad = gEl; } else e2.hidden = true;
      });
      if (bad) { var d = bad.closest('details'); if (d) d.open = true; bad.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      var q = qty(), props = {}, count = {}, up = 0;
      picks().forEach(function (x) {
        var k = x.group; count[k] = (count[k] || 0) + 1; if (count[k] > 1) k = x.group + ' (' + count[k] + ')';
        props[k] = x.option; up += x.price;
      });
      var notes = (el('[data-notes]', host).value || '').trim(); if (notes) props['Special Instructions'] = notes.slice(0, 140);
      var bid = sizes ? +el('input[name="cgm-var"]:checked', host).value : bvs[0].id;
      var bv = bvs.filter(function (v) { return +v.id === +bid; })[0] || bvs[0];
      var pv = en.length ? encVariant(p, bv, props) : pickVariant(p, bv, up);
      if (!pv && en.length) { err.textContent = 'That choice is not available online right now. Pick another, or call (562) 907-7017.'; err.classList.add('is-visible'); return; }
      if (!pv) { err.textContent = up > 0 && tierIdx(p) < 0 ? 'Paid extras for this dish are not available online yet. Remove them or call (562) 907-7017.' : 'That combination of paid extras is not available online. Remove one, or call (562) 907-7017.'; err.classList.add('is-visible'); return; }
      var vid = pv.id;
      if (+pv.id !== +bv.id && !en.length) props._bv = String(bv.id);
      var items = [{ id: vid, quantity: q, properties: props }];
      els('[data-xsell]:checked', host).forEach(function (i) { items.push({ id: +i.dataset.xsell, quantity: q }); });
      if (MODE === 'addon' && up > 0) {
        var av = ADDONS[String(up)];
        if (av) items.push({ id: av, quantity: q, properties: { _for: p.title, 'Add-ons': Object.keys(props).filter(function (k) { return k !== 'Special Instructions'; }).map(function (k) { return props[k]; }).join(', ') } });
      }
      btn.disabled = true; btn.textContent = 'Adding…';
      var go = existing ? setDish(existing, 0).then(function () { return addItems(items); }) : addItems(items);
      go.then(function () { refreshBubble(); closeSheet(); toast((existing ? 'Updated' : 'Added') + ' · ' + p.title); markCards(); pushAttributes(); })
        .catch(function (e) { btn.disabled = false; btn.textContent = 'Add to order'; err.textContent = e.message || 'Could not add this item. Try again.'; err.classList.add('is-visible'); });
    });
  }

  /* ---------- cart bar + panel ---------- */
  var bar, panel, root;
  function readyBy() {
    var d = new Date(Date.now() + PREP * 60000), h = d.getHours(), m = d.getMinutes(), ap = h >= 12 ? 'PM' : 'AM'; h = h % 12 || 12;
    return h + ':' + (m < 10 ? '0' : '') + m + ' ' + ap;
  }
  function ensureBar() {
    if (bar) return;
    bar = document.createElement('div'); bar.className = 'cgc cgc-bar cgm-bar';
    bar.innerHTML = '<div class="cgc-bar__inner"><div class="cgc-bar__meta"><strong data-sub>$0.00</strong><span data-count>0 items</span><span data-when></span></div><button type="button" class="cgc-bar__cta" data-review>Review order <span class="cgc-pill" data-pill>0</span></button></div>';
    document.body.appendChild(bar);
    el('[data-review]', bar).addEventListener('click', openPanel);
    panel = document.createElement('div'); panel.className = 'cgc cgc-modal cgm-panel';
    panel.innerHTML = '<div class="cgc-modal__panel"><button type="button" class="cgc-modal__close" aria-label="Close">×</button><div class="cgc-modal__body"><h3>Your order</h3><p class="cgm-panel__when" data-pwhen></p><div data-lines></div></div><div class="cgc-modal__foot cgm-panel__foot"><div><span>Subtotal</span><strong data-psub>$0.00</strong></div><a class="cgc-add cgm-checkout" href="/checkout">Check out</a></div></div>';
    document.body.appendChild(panel);
    panel.addEventListener('click', function (e) {
      if (e.target === panel || e.target.classList.contains('cgc-modal__close')) { panel.classList.remove('is-open'); document.body.style.overflow = ''; return; }
      if (e.target.closest('[data-change]')) { panel.classList.remove('is-open'); openSetup(); return; }
      var co = e.target.closest('.cgm-checkout'); if (co) { var v = setupValid(); if (!v.ok) { e.preventDefault(); toast(v.why); if (!v.soft) { panel.classList.remove('is-open'); openSetup(); } return; } co.href = CHECKOUT_URL; pushAttributes(); }
      var b = e.target.closest('[data-line]'); if (!b || busy) return;
      var key = b.dataset.line, act = b.dataset.act, line = (cart.items || []).filter(function (i) { return i.key === key; })[0]; if (!line) return;
      if (act === 'edit') { var p = products[line.product_id]; if (p) { panel.classList.remove('is-open'); openSheet(p, line); } return; }
      var q = act === 'inc' ? line.quantity + 1 : act === 'dec' ? line.quantity - 1 : 0;
      els('[data-line]', panel).forEach(function (x) { x.disabled = true; });
      setDish(line, Math.max(0, q)).catch(function () { toast('Could not update your order. Try again.'); paintBar(cart); });
    });
    onCart(paintBar);
  }
  function openPanel() { ensureBar(); paintBar(cart); panel.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function paintBar(c) {
    if (!bar || !c) return;
    var n = mealCount(c), sub = c.items_subtotal_price || 0;
    var pill = document.getElementById('cgoc-pill'); if (pill) { var ps = pill.querySelector('[data-sum]'); if (ps) ps.textContent = n + (n === 1 ? ' item' : ' items') + ' · ' + money(c.total_price || sub); }
    bar.classList.toggle('is-visible', n > 0);
    el('[data-sub]', bar).textContent = money(sub); el('[data-count]', bar).textContent = n + (n === 1 ? ' item' : ' items'); el('[data-pill]', bar).textContent = n;
    paintSetup();
    el('[data-psub]', panel).textContent = money(sub);
    var host = el('[data-lines]', panel);
    host.innerHTML = (c.items || []).filter(function (it) { return !isAddon(it); }).map(function (it) {
      var props = Object.keys(it.properties || {}).filter(function (k) { return k.charAt(0) !== '_' && it.properties[k]; }).map(function (k) { return esc(it.properties[k]); }).join(' · ');
      var adds = addonsFor(c, it), linePrice = it.final_line_price + adds.reduce(function (s, a) { return s + a.final_line_price; }, 0);
      if (adds.length) props += (props ? '<br>' : '') + adds.map(function (a) { var t = String(a.variant_title || a.title || '').split(': ').pop(); return '+ ' + esc(t) + ' ' + money(a.final_line_price / Math.max(1, a.quantity)); }).join(' · ');
      return '<div class="cgm-line"><div class="cgm-line__body"><div class="cgm-line__title">' + esc(it.product_title) + (lineVariantTitle(it) ? ' <small>' + esc(lineVariantTitle(it)) + '</small>' : '') + '</div>' + (props ? '<div class="cgm-line__meta">' + props + '</div>' : '') +
        '<div class="cgm-line__row"><div class="cgc-qty cgc-qty--sm"><button type="button" data-line="' + esc(it.key) + '" data-act="dec">−</button><span>' + it.quantity + '</span><button type="button" data-line="' + esc(it.key) + '" data-act="inc">+</button></div><strong>' + money(linePrice) + '</strong>' +
        (products[it.product_id] ? '<button type="button" class="cgm-line__btn" data-line="' + esc(it.key) + '" data-act="edit">Edit</button>' : '') + '<button type="button" class="cgm-line__btn" data-line="' + esc(it.key) + '" data-act="remove">Remove</button></div></div></div>';
    }).join('') || '<p class="cgc-modal__hint">Nothing in your order yet.</p>';
    el('.cgm-checkout', panel).style.display = n ? '' : 'none';
    markCards();
  }
  function markCards() {
    if (!root || !cart) return;
    var inCart = {}; (cart.items || []).forEach(function (it) { if (!isAddon(it)) inCart[it.product_id] = (inCart[it.product_id] || 0) + it.quantity; });
    els('.cgc-card', root).forEach(function (card) { var pid = card.dataset.productId; card.classList.toggle('is-in-cart', !!inCart[pid]); var t = el('.cgc-card__incart', card); if (t) t.textContent = inCart[pid] ? 'In your order · ' + inCart[pid] : ''; });
  }

  /* ---------- boot ---------- */
  var products = {}, SIDE_IDS = {}, NO_XSELL = {};
  var SIDE_ORDER = ['French Fries', 'Sweet Potato Fries', 'Onion Rings', 'Fried Zucchini', 'Fruit Cup', 'Twice Baked Potato', 'Steamed Broccoli', 'Garlic Bread'];
  function sideList(p) {
    if (!p || NO_XSELL[p.id] || SIDE_IDS[p.id]) return [];
    var en = encIdx(p);
    var hadPaid = (p.groups || []).some(function (g) { var oi = (p.onames || []).indexOf(g.name); if (oi > -1 && en.indexOf(oi) > -1) return false; return (g.options || []).some(function (o) { return o.price > 0; }); });
    if (!hadPaid) return [];
    var all = Object.keys(SIDE_IDS).map(function (k) { return products[k]; }).filter(function (s) { return s && s.available && s.variants && s.variants.length === 1; });
    all.sort(function (a, b) { var ia = SIDE_ORDER.indexOf(a.title), ib = SIDE_ORDER.indexOf(b.title); return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib); });
    return all.slice(0, 8);
  }
  function boot() {
    root = el('[data-cgm][data-order-mode="native"]'); if (!root) return;
    els('script[data-cgm-product]', root).forEach(function (s) { try { var p = JSON.parse(s.textContent); products[p.id] = p; } catch (e) {} });
    els('#cgm-om-sides script[data-cgm-product]', root).forEach(function (s) { try { SIDE_IDS[JSON.parse(s.textContent).id] = 1; } catch (e) {} });
    ['om-beverages', 'om-coffees-and-sweets', 'om-smoothie', 'om-thick-milkshakes', 'om-dessert', 'om-kids'].forEach(function (h) { els('#cgm-' + h + ' script[data-cgm-product]', root).forEach(function (s) { try { NO_XSELL[JSON.parse(s.textContent).id] = 1; } catch (e) {} }); });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-cgm-setup-open]')) { e.preventDefault(); openSetup(); return; }
      var b = e.target.closest('[data-cgm-add]'); if (!b) return;
      e.preventDefault(); var p = products[b.dataset.cgmAdd]; if (!p) return;
      if (!p.available) { toast('Sold out today'); return; }
      openSheet(p);
    });
    ensureBar();
    var ci = document.getElementById('cart-icon-bubble'); if (ci) ci.addEventListener('click', function (e) { e.preventDefault(); openPanel(); });
    loadCart().then(function () { paintSetup(); if (cart && cart.item_count) pushAttributes(); });
    paintSetup();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.CGMenu = { mealCount: mealCount, isAddon: isAddon, openSheet: openSheet, openPanel: openPanel, openSetup: openSetup, loadCart: loadCart, setup: function () { return setup; }, attributes: cartAttributes };
})();
